<style scoped>
    .menu-c {
        display: flex;
        flex-direction: column;
        z-index: 20;
        background: white;
    }
    .search-c {
        padding: 10px;
    }
    .content-c {
        flex: 1;
        overflow: auto;
        padding: 10px;
    }
    .content-item {
        padding: 10px 10px 0;
         cursor: pointer;
    }
        .content-item:hover {
        background: #eeeeee;
    }
    .i-con {
        cursor: pointer;
        margin: 0px 5px;
    }
</style>
<template>
  <v-menu
    ref="menu"
    v-model="menu"
    content-class="menu-c"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    top
    auto
    :max-height="contentHeigh"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        fab
        color="error"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon dark>
          mdi-minus-circle-outline
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        {{ title }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />

        <v-btn
          text
          @click="menu = false"
        >
          取消
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="submit"
        >
          确定
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
  export default {
  
    props: {
      icon: {
        type: String,
        default: () => 'mdi-minus-circle-outline'
      },
      title: {
        type: String,
      },
      contentHeigh: {
        type:Number
      }
      
    },
    data() {
      return {
        menu: false,
      }
    },
    methods: {
      submit() {
        this.$emit('submit')
        this.menu = false
      }
    }
  }
</script>
